import styles from "./complaintsdetails.module.css";
import { Link, useHistory } from "react-router-dom";
import Helmet from "react-helmet";
import { Home, ArrowLeft, ChevronDown, X } from "react-feather";
import { Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton, Snackbar, Slide } from "@mui/material";
import { Dropdown } from "react-bootstrap";
import Footer from "../../components/Footer";
import Loader from "../../components/Loader";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { useState, useEffect } from "react";
import { TableLoader } from "../../components/LoaderC";
import axios from "axios";
import ComplaintCard from "./components/details/ComplaintCard";
import { AddLogCallAPI } from "../../components/AddLogs";
import { toast } from "react-smart-toaster";
import AddComplaint from "./components/AddComplaint";
import { forwardRef } from "react";
import ComplaintTab from "./components/details/ComplaintTab";
import ComplaintDetailsMobile from "./components/details/ComplaintDetailsMobile";

const OpenedToggleReadOnly = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.ReferStatusBUNew} ${styles.Open}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Open</button>));

const ResolvedToggleReadOnly = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.ReferStatusBUNew} ${styles.Resolved}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Resolved</button>));

const CancelledToggleReadOnly = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.ReferStatusBUNew} ${styles.Cancelled}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Cancelled</button>));

const OpenedToggle = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.Open}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Open <ChevronDown className={`${styles.DownArrowStatus}`} /></button>));

const ResolvedToggle = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.Resolved}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Resolved <ChevronDown className={`${styles.DownArrowStatus}`} /></button>));

const CancelledToggle = forwardRef(({ children, onClick }, ref) => (<button ref={ref} className={`${styles.ReferStatusBU} ${styles.Cancelled}`} onClick={(e) => { e.preventDefault(); onClick(e); }}>Cancelled <ChevronDown className={`${styles.DownArrowStatus}`} /></button>));

const ComplaintsDetails = ({ history, match }) => {
  const { id } = match.params;
  const redirect = useHistory();
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [complaintData, setComplaintData] = useState(null);
  const [delModalOpen, setDelModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  useEffect(() => {
    async function fetchCompliaintDetails() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      setContentLoading(true);
      await axios.get(process.env.REACT_APP_CASE_API_URL + "v1/complaints/" + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setContentLoading(false);
        setComplaintData(response.data.data);

      }).catch((error) => {
        setContentLoading(false);
      });
    }

    fetchCompliaintDetails();
  }, [getAccessTokenSilently, id]);

  const delConfirm = async () => {
    setDelModalOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_CASE_API_URL + "v1/complaints/" + complaintData?.id, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      let logData = {
        title: "Complaint has been deleted",
        description: [
          "Name: " + response.data.data?.title,
          "Request number: " + response.data.data?.complaint_no,
          "Property: " + response.data.data?.property_name,
          "Apartment: " + response.data.data?.apt_name,
          "Tenant: " + response.data.data?.tenant_name,
        ],
      };
      AddLogCallAPI(logData, token);
      setTimeout(() => {
        redirect.push("/cases/complaints");
      }, 2000);
    }).catch((error) => {
      setLoading(false);
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  const onUpdateLocal = (data) => {
    setComplaintData(data);
  }

  const changeCStatus = async (item, cVal) => {
    if (item?.current_status !== cVal) {
      setLoading(true);

      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios.put(process.env.REACT_APP_CASE_API_URL + 'v1/complaints/' + item?.id, { 'current_status': cVal }, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then(response => {
        setLoading(false);
        setSnackbarMsg(response.data.message);
        setSnackbarOpen(true);

        setComplaintData(prev => {
          return { ...prev, current_status: cVal };
        })

        let logData = {
          'title': 'Complaint status has been updated',
          'description': [
            'Name: ' + response.data.data.title,
            'Complaints number: ' + response.data.data.complaint_no,
            'Apartment: ' + response.data.data.property_name + ' - ' + response.data.data.apt_name,
            'Tenant: ' + response.data.data.tenant_name
          ]
        }
        AddLogCallAPI(logData, token);
      }).catch(error => {
        setLoading(false);
        if (typeof error.response !== 'undefined')
          toast.error(error.response.data.message);
      });
    }
  }

  return (<>
    {loading && <Loader />}
    <Helmet title={complaintData?.title} />
    <div className={`${styles.mainCard}`}>

      {contentLoading && (<div className="Loader TableLoader">
        <TableLoader />
      </div>)}

      {!contentLoading && <div className={`${styles.SMProCusRow}`}>

        <div className={`${styles.BreadcrumbHeadSec}`}>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Cases</li>
              <li className={`${styles.breadcrumbItem}`}>
                <Link to={"/cases/complaints"}>Complaints</Link>
              </li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>{complaintData?.title}</li>
            </ol>
          </nav>
          <div className={`${styles.PageTitleSec}`}>
            <div>
              <button onClick={() => redirect.goBack()} className={`${styles.BackArrow}`}><ArrowLeft /></button>
              <Typography display="inline" className={`${styles.pageTitle}`}>{complaintData?.title}</Typography>
            </div>
          </div>
        </div>

        <ComplaintCard complaintData={complaintData} setDelModalOpen={setDelModalOpen.bind(this)} setEditModalOpen={setEditModalOpen.bind(this)} />

        <div className={`${styles.SMReferDeBigDiv}`}>
          <div className={`${styles.Card}`}>
            <div className={`${styles.cardbody}`}>
              <div className={`${styles.ActionRefMain}`}>
                <div className={`${styles.TitleSummary}`}>
                  <p className={`${styles.Title}`}>{complaintData?.title}</p>
                  <div className={`${styles.MainReqConDropBU}`}>
                    {!(isAuthenticated && user['https://propertydek.com/permissions'].indexOf('complaint:update') > -1) && <Dropdown>
                      {complaintData?.current_status === 0 && <Dropdown.Toggle as={OpenedToggleReadOnly} />}
                      {complaintData?.current_status === 2 && <Dropdown.Toggle as={ResolvedToggleReadOnly} />}
                      {complaintData?.current_status === 3 && <Dropdown.Toggle as={CancelledToggleReadOnly} />}
                    </Dropdown>}
                    {(isAuthenticated && user['https://propertydek.com/permissions'].indexOf('complaint:update') > -1) && <Dropdown>
                      {complaintData?.current_status === 0 && <Dropdown.Toggle as={OpenedToggle} />}
                      {complaintData?.current_status === 2 && <Dropdown.Toggle as={ResolvedToggle} />}
                      {complaintData?.current_status === 3 && <Dropdown.Toggle as={CancelledToggle} />}
                      <Dropdown.Menu className="DropDownMenuBoxCus">
                        <Dropdown.Item className="DropDListWIcon" onClick={(e) => changeCStatus(complaintData, 0)}>Open</Dropdown.Item>
                        <Dropdown.Item className="DropDListWIcon" onClick={(e) => changeCStatus(complaintData, 2)}>Resolved</Dropdown.Item>
                        <Dropdown.Item className="DropDListWIcon" onClick={(e) => changeCStatus(complaintData, 3)}>Cancelled</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>}
                  </div>
                </div>
              </div>
              <div className={`${styles.SMBigSideBody} TabMainClientProfile ClientDetails`}>
                <ComplaintTab complaintData={complaintData} setComplaintData={setComplaintData.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} />
              </div>
            </div>
          </div>
        </div>

      </div>}
    </div>

    <ComplaintDetailsMobile complaintData={complaintData} setComplaintData={setComplaintData.bind(this)} setDelModalOpen={setDelModalOpen.bind(this)} setEditModalOpen={setEditModalOpen.bind(this)} changeCStatus={changeCStatus.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} />

    <Dialog
      open={editModalOpen}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setEditModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => setEditModalOpen(false)}><ArrowLeft /></button>
        <span>Edit Complaint</span>
        <button onClick={(e) => setEditModalOpen(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        <AddComplaint setAddModalOpen={setEditModalOpen.bind(this)} tenant_id={0} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} onSubmitLocal={onUpdateLocal.bind(this)} complaintData={complaintData} />
      </DialogContent>
    </Dialog>

    <Dialog
      open={delModalOpen}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setDelModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to delete the complaint?
        <button onClick={(e) => setDelModalOpen(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The complaint record will be removed immediately. You can't undo this action.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => delConfirm()}>Delete</Button>
        <Button onClick={(e) => setDelModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />

    <Footer />
  </>);
}

export default withAuthenticationRequired(ComplaintsDetails, {
  onRedirecting: () => <Loader />,
});